import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor
} from '@angular/common/http';
import { from, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '@aveva/connect-web-core';
import * as globals from '../training/globals';
import { LoggingService } from '../services/logging.service';

@Injectable({
  providedIn: 'root'
})

export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private logger: LoggingService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    try {

      if(req.url.includes(environment.apis.connect) || req.url.includes(environment.apis.cds)) {
        const token = await this.authenticationService.getToken();

        req = req.clone({
          headers: req.headers.append(globals.AUTHORIZATION, `${globals.BEARER}${token}`) 
        });
      }

      return lastValueFrom(next.handle(req));
    }
    catch (error) {
      this.logger.logException(error);
      return lastValueFrom(next.handle(req));
    }
  }
}
